// Utility functions for managing rastId across the application

export const getRastId = () => {
  // First check localStorage
  const rastId = localStorage.getItem('rastId');
  
  if (rastId) {
    return rastId;
  }
  
  // Fallback to cookies if localStorage doesn't have it
  const cookies = document.cookie.split(';');
  for (let cookie of cookies) {
    const [name, value] = cookie.trim().split('=');
    if (name === 'rastId') {
      // Store in localStorage for future use
      localStorage.setItem('rastId', value);
      return value;
    }
  }
  
  return null;
};

export const setRastId = (rastId) => {
  if (rastId) {
    // Store in localStorage
    localStorage.setItem('rastId', rastId);
    
    // Also store in cookies as backup (24 hours)
    const expiryDate = new Date();
    expiryDate.setDate(expiryDate.getDate() + 1);
    document.cookie = `rastId=${rastId}; expires=${expiryDate.toUTCString()}; path=/`;
  }
};

export const clearRastId = () => {
  // Clear from localStorage
  localStorage.removeItem('rastId');
  
  // Clear cookie
  document.cookie = 'rastId=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
};

export const hasRastId = () => {
  return getRastId() !== null;
};
